import React from 'react';
import { Helmet } from 'react-helmet'
// import 'bootstrap/dist/js/bootstrap.bundle';


const Table = () => {

    return (
        <div>

            <Helmet>
   <script src="assets/vendor/datatables.net/js/jquery.dataTables.min.js"></script>
   <script src="assets/vendor/datatables.net-bs5/js/dataTables.bootstrap5.min.js"></script>
   <script src="assets/vendor/datatables.net-responsive/js/dataTables.responsive.min.js"></script>
   <script src="assets/vendor/datatables.net-responsive-bs5/js/responsive.bootstrap5.min.js"></script>
   <script src="assets/vendor/datatables.net-fixedcolumns-bs5/js/fixedColumns.bootstrap5.min.js"></script>
   {/* <script src="assets/vendor/datatables.net-fixedheader/js/dataTables.fixedHeader.min.js"></script> */}
   <script src="https://cdn.datatables.net/fixedheader/3.2.4/js/dataTables.fixedHeader.min.js"></script>

   <script src="assets/vendor/datatables.net-buttons/js/dataTables.buttons.min.js"></script>
   <script src="assets/vendor/datatables.net-buttons-bs5/js/buttons.bootstrap5.min.js"></script>
   <script src="assets/vendor/datatables.net-buttons/js/buttons.html5.min.js"></script>
   <script src="assets/vendor/datatables.net-buttons/js/buttons.flash.min.js"></script>
   <script src="assets/vendor/datatables.net-buttons/js/buttons.print.min.js"></script>
   <script src="assets/vendor/datatables.net-keytable/js/dataTables.keyTable.min.js"></script>
   <script src="assets/vendor/datatables.net-select/js/dataTables.select.min.js"></script>

   <script src="assets/js/pages/demo.datatable-init.js"></script>

   <script src="assets/js/app.min.js"></script>

                



            </Helmet>
        </div>
    )
}

export default Table
